import { Routes } from '@angular/router'
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { AuthGuard } from './auth/auth.guard';
import { Page1Component } from './page1/page1.component';
import { MenuComponent } from './menu/menu.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { MainPageComponent } from './main-page/main-page.component';
import { UserManagementService } from './service/user-management.service';
//import { TripCyclesComponent } from './trip-cycles/trip-cycles.component';
import { TripPaymentCardsDetailsVFSuccessComponent } from './tip-card-change/TripPaymentCardsDetailsVFSuccess/TripPaymentCardsDetailsVFSuccess.component';
import { TripPaymentCardsDetailsVFErrorComponent } from './tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component';
import { TripPaymentCardsDetailsVFCancelComponent } from './tip-card-change/TripPaymentCardsDetailsVFCancel/TripPaymentCardsDetailsVFCancel.component';
//import { TripCycleDetailsComponent } from './trip-cycle-details/trip-cycle-details.component';
import { TripCycles2Component } from './trip-cycles-2/trip-cycles-2.component';

export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'page1', component: Page1Component, canActivate: [AuthGuard] },
    {
        path: 'signup', component: UserComponent,
        children: [{ path: '', component: SignUpComponent }]
    }, 
    {
        path: 'login', component: UserComponent,
        children: [{ path: '', component: SignInComponent }]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'menu', component: MenuComponent },
    { path: 'main-page', component: MainPageComponent },
    // { path: 'trip-cycles', component: TripCyclesComponent },
    { path: 'trip-cycles-2', component: TripCycles2Component },
    // { path: 'trip-cycles/:catid/:sid/:cid/:statusid/:grouper', component: TripCyclesComponent },
    { path: 'trip-cycles-2/:catid/:sid/:cid/:statusid/:grouper', component: TripCycles2Component },
    // { path: 'trip-cycle-details/:catid/:sid/:cid/:statusid/:grouper', component: TripCycleDetailsComponent },
    { path: 'TripPaymentCardsDetailsVFSuccess/:pid/:catid/:sid/:cid/:statusid/:grouper', component: TripPaymentCardsDetailsVFSuccessComponent },
    { path: 'TripPaymentCardsDetailsVFError/:pid/:catid/:sid/:cid/:statusid/:grouper', component: TripPaymentCardsDetailsVFErrorComponent },
    { path: 'TripPaymentCardsDetailsVFCancel/:pid/:catid/:sid/:cid/:statusid/:grouper', component: TripPaymentCardsDetailsVFCancelComponent },

    

    //{ path: 'lpi/:invoice', component: LPInvoiceDetailsComponent },

    { path: 'error-page/:id', component: ErrorPageComponent },
    { path: "**", component: ErrorPageComponent },
];



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/routes.ts